import { render, staticRenderFns } from "./ImageCropper.vue?vue&type=template&id=0807d9e2&scoped=true"
import script from "./ImageCropper.vue?vue&type=script&lang=js"
export * from "./ImageCropper.vue?vue&type=script&lang=js"
import style0 from "./ImageCropper.vue?vue&type=style&index=0&id=0807d9e2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0807d9e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/examreg-client-prod-tc/exam-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0807d9e2')) {
      api.createRecord('0807d9e2', component.options)
    } else {
      api.reload('0807d9e2', component.options)
    }
    module.hot.accept("./ImageCropper.vue?vue&type=template&id=0807d9e2&scoped=true", function () {
      api.rerender('0807d9e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ImageCropper.vue"
export default component.exports